import { buildMeta, getCompanyFromMatches } from "~/utils/meta-helpers";

import { TERMS_UPDATED_AT, TermsContent } from "../components/legal/TermsContent";
import { LegalPage } from "../components/LegalPage";

import type { MetaFunction } from "@remix-run/node";

export const meta: MetaFunction = ({ matches }) => {
  const company = getCompanyFromMatches(matches);
  return buildMeta({
    title: `Términos y Condiciones | ${company}`,
    description: "Términos y condiciones de uso de la plataforma de cursos AcademIA.",
    path: "/terms",
  });
};

export default function TermsPage() {
  return (
    <LegalPage eyebrow="Legal" title="Términos y Condiciones" updatedAt={TERMS_UPDATED_AT}>
      <TermsContent />
    </LegalPage>
  );
}
